// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBanOpen() {
  const html = $('html')[0];
  if (html.classList.contains('is-hidden')) return;

  scrollTop = window.scrollY;
  // スクロールバー消失による幅ガタつきを防ぐ
  const gap = window.innerWidth - html.clientWidth;
  html.style.setProperty('--scroll-ban-gap', `${gap}px`);
  html.style.top = (scrollTop * -1) + 'px';
  html.classList.add('is-hidden');
  $('html').css({ 'scroll-behavior': 'inherit' });
}

function scrollBanClose() {
  const html = $('html')[0];
  if (!html.classList.contains('is-hidden')) return;

  html.classList.remove('is-hidden');
  html.style.top = '';
  html.style.removeProperty('--scroll-ban-gap');
  window.scrollTo(0, scrollTop);
  $('html').css({ 'scroll-behavior': 'smooth' });
}

function scrollBan() {
  if ($('html')[0].classList.contains('is-hidden')) {
    scrollBanClose();
  } else {
    scrollBanOpen();
  }
}

// 旧関数名の互換（typo含む）
function scrollBanClase() {
  scrollBanClose();
}
